import { createApp } from 'vue'
import App from '@/apps/SearchBarApp.vue'
import mixins from '@/mixins'

const $app = document.getElementById('searchbar') as HTMLElement;

createApp(App, {
    categoryId: $app.getAttribute('data-category-id'),
})
.mixin(mixins)
.mount($app);
